// A labelled pill field with its error or hint underneath, as Criar conta
// (SPEC-14) and Entrar (SPEC-15) draw it. On error the border and the label
// turn orange (the Entrar mockup) and the message is tied to the input.

import { useId } from "react";
import type { InputHTMLAttributes, ReactNode } from "react";

export function Field({
  label,
  error,
  hint,
  children,
  ...input
}: {
  label: string;
  error: ReactNode;
  hint?: string;
  children?: ReactNode;
} & InputHTMLAttributes<HTMLInputElement>) {
  const id = useId();
  let described: string | undefined;
  if (error) described = `${id}-error`;
  else if (hint) described = `${id}-hint`;
  return (
    <div className="group flex flex-col gap-2">
      <label
        htmlFor={id}
        className={`text-body-sm font-semibold ${error ? "text-orange-ink" : "text-dark group-focus-within:text-violet"}`}
      >
        {label}
      </label>
      <input
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={described}
        className={
          "h-[var(--control-h)] w-full rounded-pill border-[1.5px] bg-transparent px-5 text-body-lg text-dark " +
          "outline-none placeholder:text-muted transition-colors duration-[var(--dur-micro)] ease-pyf " +
          (error ? "border-orange" : "border-line-20 focus:border-violet")
        }
        {...input}
      />
      {error ? (
        <p id={`${id}-error`} className="px-5 text-caption text-orange-ink">
          {error}
        </p>
      ) : (
        hint && (
          <p id={`${id}-hint`} className="px-5 text-caption text-muted">
            {hint}
          </p>
        )
      )}
      {children}
    </div>
  );
}
